// SHOULD ONLY BE IMPORTED FROM WITHIN THE APP //
import { environment } from './../../../src/environments/environment';

export const apiLink = `${environment.functionsURL}api/app`